import styled from "styled-components";

export const Title = styled.h1`
  margin: 0 0 1rem;

  font-family: Inter;
  font-size: 1.25;
  font-weight: 700;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.colors?.textColor};
`;
